import "core-js/modules/es.string.link.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useBreakpoints from 'hooks/useBreakpoints';
import useVisibleScreenContext from 'hooks/useVisibleScreenContext';
import Button from 'components/Button';
import Text from 'components/Text';
import Flex from 'components/Flex';
import Box from 'components/Box';
import Card from 'components/Card';
import TextLink from 'components/TextLink';
import PercentageDisc from 'components/PercentageDisc';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MeetingItem(_ref) {
  var score = _ref.score,
    title = _ref.title,
    subtitle = _ref.subtitle,
    link = _ref.link,
    screenContext = _ref.screenContext;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBreakpoints = useBreakpoints(),
    isDesktopOrTablet = _useBreakpoints.xs;
  var watchedElementRef = useVisibleScreenContext(screenContext !== null && screenContext !== void 0 ? screenContext : null);
  return /*#__PURE__*/_jsx(Card, {
    ref: watchedElementRef,
    variant: "clickable",
    px: "m",
    py: 12,
    position: "relative",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        grow: true,
        shrink: true,
        gap: "m",
        children: [(score || score === 0) && /*#__PURE__*/_jsx(PercentageDisc, {
          size: "small",
          shady: true,
          percentage: score
        }), /*#__PURE__*/_jsxs(TextLink, {
          bold: true,
          as: Link,
          to: link,
          children: [t(title), /*#__PURE__*/_jsx(Box
          // Extend clickable area across whole banner
          , {
            fillParent: true
          })]
        }), isDesktopOrTablet && subtitle && /*#__PURE__*/_jsx(Text, {
          overflow: "wrap",
          dimmed: true,
          children: subtitle
        })]
      }), /*#__PURE__*/_jsx(Button, {
        iconOnly: true,
        icon: "arrow-right",
        size: "medium",
        variant: "transparent",
        as: Link,
        to: link,
        children: t('actions_view_meeting', {
          name: title
        })
      })]
    })
  });
}
export default MeetingItem;